import bizNodeModel from '../../bizNodeModel.mjs'

export default bizNodeModel({
    umUserCode: {
        name: () => '系统入口代码',
    },

    umName: {
        name: () => '系统入口名称',
        required: () => true,
    },
})
